import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import back_prize from '../../../static/images_cso/back_prize.png';
import login_prize from '../../../static/images_cso/login_prize.png';
import medical_heart from '../../../static/images_cso/medical_heart.png';
import close from '../../../static/images_cso/close.png';

let env = process.env.REACT_APP_ENV;

const api = new ApiCore();

const MedicalConsult = (props: any, refs: any) => {

    const [showDialog, setShowDialog] = useState<boolean>(true);
    const [imgUrl, setImgUrl] = useState<string>(login_prize);
    const [type, setType] = useState<any>(2);

    useEffect(() => {
        let type = props?.activityInfo?.code == 'DW001' ? 1 : 2; // DW001, DW002
        setType(type);
        initData(type);
        // 记录
        api.actionRecordSave({ type: 'DuanWu' });
        return () => {
        }
    }, [])


    // 展示弹框
    useImperativeHandle(refs, () => ({
        toShow,
        toClose
    }));

    const initData = (type: any) => {
        if (env === 'test' || env === 'development') {
            // 测试环境
            setImgUrl(type == 1 ? back_prize : login_prize);
        } else {
            // 线上环境
            setImgUrl(type == 1 ? back_prize : login_prize);
        }
    }

    const toShow = () => {
        setShowDialog(true);
    }

    const toClose = () => {
        setShowDialog(false);
    }

    const toJump = () => {
        window.location.href = 'https://hmez.huimeihealth.com.cn/hm/scrm/scrmmobile/eda/1670676793018605568?aid=1_tid%3D28';
    }

    return (
        <div className={styles.medical_consult_content} style={{ display: showDialog ? 'block' : 'none' }}>
             <div className={styles.dialog}>
                <div className={styles.title}>
                    {
                        type == 1 ? '回归有礼' : type == 2 ? '登录有礼' : ''
                    }
                </div>
                <div className={styles.content}>
                    {
                        type == 1 ? '欢迎您回归！老用户惊喜好礼，即日起至6月30日~阅读文章即可领取双倍积分，兑换丰厚礼品！' : 
                        type == 2 ? '欢迎您登录！端午惊喜好礼，即日起至6月30日~阅读文章即可领取双倍积分，兑换丰厚礼品！' : ' '
                    }
                </div>
                {/* {
                    type && 
                    <div className={styles.shop_wrap}>
                        <div className={styles.medical_consultant_wrap}>
                            <img className={styles.medical_heart} src={medical_heart} alt="" />
                            <img className={styles.medical_consultant} src={imgUrl} alt="" />
                        </div>
                    </div>
                } */}
                {
                    type &&
                    <div className={styles.to_btn_wrap} onClick={toJump}>
                        <img className={styles.prize_heart} src={medical_heart} alt="" />
                        <div className={styles.to_btn}>阅读文章</div>
                    </div>
                }
                {/* <div className={styles.word}>
                    {
                        type == 1 ? '长按识别，领取积分' : type == 2 ? '长按识别，领取积分' : ''
                    }
                </div> */}
                <div className={styles.close_wrap}>
                    <img src={close} onClick={toClose} alt="" />
                </div>
             </div>
             <div className={styles.mask}></div>
        </div>
    )
}

export default forwardRef(MedicalConsult);